/* MotoWing: sepet sayfası (sections/mw-cart). Adet −/+ / sil / elle adet: /cart/change.js, ardından bölüm sayfa yenilenmeden yeniden çizilir ve başlıktaki sepet sayısı güncellenir (alt menü sayacı onu izler). Başka yerden sepete ürün eklenirse (hızlı ekle) bölüm tazelenir. Kargo tarihi: Pzt/Çar/Cuma kuralı, İstanbul saati (UTC+3 sabit), sabit tatiller atlanır, teslim 1–3 iş günü. */
(function(){
  if(window.mwCartInit) return; window.mwCartInit=1;
  var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/', busy=false;
  function box(){ return document.querySelector('[data-mw-ct]'); }
  function eta(){
    var p=document.querySelector('[data-mw-ct-eta]'); if(!p) return;
    try{
      var H=['01-01','04-23','05-01','05-19','07-15','08-30','10-29'];
      var TRM=['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'], TRD=['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
      var hol=function(x){ return H.indexOf(('0'+(x.getMonth()+1)).slice(-2)+'-'+('0'+x.getDate()).slice(-2))>-1; };
      var t=new Date(Date.now()+108e5), d=new Date(t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate()), sd=null, si=0;
      for(var i=1;15>i;i++){ var n=new Date(d.getFullYear(),d.getMonth(),d.getDate()+i), w=n.getDay(); if((w===1||w===3||w===5)&&!hol(n)){ sd=n; si=i; break; } }
      if(!sd) return;
      var bd=function(from,k){ var x=new Date(from.getFullYear(),from.getMonth(),from.getDate()), c=0; while(k>c){ x.setDate(x.getDate()+1); var wd=x.getDay(); if(wd!==0&&wd!==6&&!hol(x)) c++; } return x; };
      var f=function(x){ return x.getDate()+' '+TRM[x.getMonth()]; };
      var a=bd(sd,1), b=bd(sd,3), dn=si===1?'Yarın':TRD[sd.getDay()];
      var rng=a.getMonth()===b.getMonth()?a.getDate()+'–'+f(b):f(a)+' – '+f(b);
      p.innerHTML='Şimdi sipariş verirsen <b>'+dn+' ('+f(sd)+')</b> kargoda · tahmini teslim <b>'+rng+'</b>';
      p.hidden=false;
    }catch(e){}
  }
  function bubble(){
    fetch(R+'?sections=cart-icon-bubble',{credentials:'same-origin'}).then(function(r){ return r.ok?r.json():null; }).then(function(j){
      var el=document.getElementById('cart-icon-bubble'); if(!j||!el||!j['cart-icon-bubble']) return;
      var d=document.createElement('div'); d.innerHTML=j['cart-icon-bubble']; var s=d.querySelector('.shopify-section'); el.innerHTML=(s||d).innerHTML;
    }).catch(function(){});
  }
  function refresh(){
    var b=box(); if(!b) return Promise.resolve();
    return fetch(window.location.pathname+'?section_id='+encodeURIComponent(b.getAttribute('data-sid')),{credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(h){
      var d=document.createElement('div'); d.innerHTML=h; var n=d.querySelector('[data-mw-ct]'), o=box();
      if(n&&o) o.parentNode.replaceChild(n,o);
      eta(); bubble();
    });
  }
  function err(m){ var e=document.querySelector('[data-mw-ct-err]'); if(!e) return; e.textContent=m||''; e.hidden=!m; }
  function change(key,q){
    if(busy||!key) return; busy=true;
    var b=box(); if(b) b.classList.add('is-busy');
    fetch(R+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,q)})})
    .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; }); })
    .then(function(x){
      if(!x.ok){ err(x.j&&(x.j.description||x.j.message)||'Sepet güncellenemedi, tekrar dene.'); var b2=box(); if(b2) b2.classList.remove('is-busy'); return; }
      if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'mw-cart',cartData:x.j});
      return refresh();
    })
    .catch(function(){ err('Bağlantı hatası, tekrar dene.'); var b3=box(); if(b3) b3.classList.remove('is-busy'); })
    .then(function(){ busy=false; });
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-mw-ct-q]'); if(!t||!box()||!box().contains(t)) return;
    e.preventDefault(); change(t.getAttribute('data-key'),parseInt(t.getAttribute('data-q'),10)||0);
  });
  document.addEventListener('change',function(e){
    var t=e.target.closest&&e.target.closest('[data-mw-ct-in]'); if(!t) return;
    var v=parseInt(t.value,10); if(isNaN(v)||v<0) v=0; change(t.getAttribute('data-key'),v);
  });
  document.addEventListener('keydown',function(e){ var t=e.target.closest&&e.target.closest('[data-mw-ct-in]'); if(t&&e.key==='Enter'){ e.preventDefault(); t.blur(); } });
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined') subscribe(PUB_SUB_EVENTS.cartUpdate,function(ev){ if(ev&&ev.source!=='mw-cart'&&box()) refresh(); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',eta); else eta();
})();